import { Page, View, Image, Text, Link } from '@react-pdf/renderer';
import { styles } from './styles';
import bgImage from '@assets/images/bg_speakers.png';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';
import { globalStyles } from '@composites/PDF/AgendaPdfContent/styles';
import { APP_HOST } from '@utils/apiHooks';

export interface MatchMakingOne2OneMeetingsPageProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const MatchMakingOne2OneMeetingsPage = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: MatchMakingOne2OneMeetingsPageProps) => {
  const { t } = useTranslation();

  return (
    <Page size="A4" orientation="portrait" style={{ paddingBottom: 100 }}>
      {header}

      <View>
        <Text
          style={{
            ...globalStyles.bigTitle,
            color: event?.design?.themeColor,
            fontSize: 24,
            textTransform: 'uppercase',
          }}
        >
          {t('match-making-&-one2one-meetings')}
        </Text>
        <View
          style={{
            ...globalStyles.lineBar,
            borderColor: event?.design?.themeColor ?? 'black',
          }}
        />
      </View>

      <View style={styles.contentWrapper}>
        <View style={styles.gridContainer}>
          {[...Array(9)].map((value, index) => (
            <View key={`match-making-item-${index}`} style={styles.gridItem}>
              <Text style={styles.gridItemTitle}>
                {t(`match-making-&-one2one-meetings-item-${index + 1}-title`)}
              </Text>
              <Text style={styles.gridItemText}>
                {t(`match-making-&-one2one-meetings-item-${index + 1}-text`)}
              </Text>
            </View>
          ))}
        </View>
      </View>

      <View style={styles.downloadThePartnerBrochureWrapper}>
        <Image style={styles.downloadImage} src={bgImage} />
        <Text style={styles.downloadThePartnerBrochureTitle}>
          {t('become-a-partner')}
        </Text>
        <Text style={styles.downloadThePartnerBrochureText}>
          {t('get-ready-for-the-event-of-the-year')}
        </Text>

        <View style={styles.downloadThePartnerBrochureButtonWrapper}>
          <Link
            src={`${APP_HOST}/events/${event?.slug}/business-partner.pdf`}
            style={styles.downloadThePartnerBrochureButton}
          >
            {t('download-the-partner-brochure')}
          </Link>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default MatchMakingOne2OneMeetingsPage;
